/**
 * PlaceholderScreen — usada durante Fase 4 para todas las rutas que aún no
 * tienen pantalla real. Cada ruta recibe su EmptyState con el nombre humano
 * de la ruta. Las pantallas reales (Dashboard, PlanBuilder, etc.) se
 * implementan en Fase 5 reemplazando este componente en App.tsx.
 */
import { EmptyState } from "../lib/components";
import { ROUTE_TITLES, type Route } from "../types";

interface PlaceholderScreenProps {
  route: Route;
}

const ICONS: Partial<Record<Route, string>> = {
  dashboard: "home",
  templates: "grid",
  clients: "user",
  library: "book",
  measurements: "sparkle",
  brand: "star",
  config: "settings",
  "plan-builder": "hammer",
  "share-link": "send",
  "admin-dashboard": "settings",
  "admin-users": "user",
  "admin-payments": "money",
  "admin-reports": "sparkle",
  "public-plan": "book",
  terms: "book",
  privacy: "book",
};

export function PlaceholderScreen({ route }: PlaceholderScreenProps) {
  const title = ROUTE_TITLES[route] || route;
  const icon = ICONS[route] || "sparkle";

  // TODO Fase 5 — reemplazar este placeholder por las screens reales:
  //   dashboard       → src/screens/Dashboard.tsx (KPIs + planes recientes)
  //   templates       → src/screens/TemplatesScreen.tsx
  //   clients         → src/screens/ClientsScreen.tsx (CRUD clientes)
  //   library         → src/screens/LibraryScreen.tsx (catálogo + GIFs)
  //   measurements    → src/screens/MeasurementsScreen.tsx
  //   brand           → src/screens/BrandScreen.tsx (form Mi Marca)
  //   config          → src/screens/ConfigScreen.tsx
  //   plan-builder    → src/screens/PlanBuilderScreen.tsx (editor A4 secciones)
  //   share-link      → src/screens/ShareLinkScreen.tsx
  //   admin-*         → src/screens/admin/*.tsx (Fase 6)
  //   public-plan     → src/screens/PublicPlanScreen.tsx (Fase 7)

  return (
    <div className="page" style={{ paddingTop: 48 }}>
      <EmptyState
        icon={icon}
        title={`Próximamente · ${title}`}
        body="Esta pantalla forma parte de la migración a React. La versión real llega en la siguiente fase del plan. Mientras tanto, podés navegar el shell y verificar que la marca, los colores y los Tweaks funcionan."
      />
    </div>
  );
}
